export const FETCH_MY_LATE_TASK_LISTING_REQUEST = 'FETCH_MY_LATE_TASK_LISTING_REQUEST'
export const FETCH_MY_LATE_TASK_LISTING_SUCCESS = 'FETCH_MY_LATE_TASK_LISTING_SUCCESS'
export const FETCH_MY_LATE_TASK_LISTING_FALUIRE = 'FETCH_MY_LATE_TASK_LISTING_FALUIRE'
export const FETCH_MY_LATE_TASK_MINUUS_ONE_LISTING_FALUIRE = 'FETCH_MY_LATE_TASK_MINUUS_ONE_LISTING_FALUIRE'
export const FETCH_SEARCH_M_L_TASK ='FETCH_SEARCH_M_L_TASK'